interface Template {
    name: string;
    file: string;
}

export default class KendoTemplateLoader {
    templatePath = '/js/templates';
    templateExtension = 'htm';
    templateSuffix = '';
    pendingLoads: { [id: string]: JQueryPromise<string>; } = {};

    require(...templates: Template[]): JQueryPromise<string> {
        return $.Deferred((promise: JQueryDeferred<string>) => {
            const templatePromises = $.map(templates, (template) => {
                if (typeof (template) === 'string') {
                    return this.getTemplate(template);
                }
                return this.getTemplate(template.name, template.file);
            });
            $.when(...templatePromises).done(promise.resolve);
        });
    }

    getTemplate(name: string, file?: string): JQueryPromise<string> {
        const resultingFile = file || name;
        const dfd = $.Deferred<string>();

        $.when(KendoTemplateLoader.lookupTemplate(name))
            .done(() => {
                dfd.resolve();
            })
            .fail(() => {
                $.when(this.loadTemplate(name, resultingFile))
                    .then(dfd.resolve)
                    .fail(dfd.reject);
            });
        return dfd;
    }

    static lookupTemplate(name: string): JQueryPromise<string> {
        const templateScriptElement: JQuery = $(`script[type="text/x-kendo-template"][name="${name}"]`);
        const dfd = $.Deferred<string>();

        if (templateScriptElement.length) {
            dfd.resolve(templateScriptElement.text());
        } else {
            dfd.reject();
        }
        return dfd;
    }

    loadTemplate(name: string, file?: string): JQueryPromise<string> {
        let resultingFile = file || name;
        resultingFile = resultingFile.split('--').join('/');

        const dfd = $.Deferred<string>();
        const pendingDownload = this.pendingLoads[resultingFile];
        if (pendingDownload) {
            pendingDownload.then((data) => {
                dfd.resolve(data);
            });
            return dfd;
        }

        this.pendingLoads[resultingFile] = dfd;
        $.ajax({
            url: this.getTemplateFilePath(resultingFile),
            dataType: 'html'
        }).then((data: string) => {
            const resultingData = data.trim();
            this.writeTemplate(name, resultingData);
            this.resolveChildTemplates(resultingData)
                .then(() => {
                    dfd.resolve(resultingData);
                });
        }).fail((e) => {
            dfd.reject(e);
        });

        return dfd;
    }

    resolveChildTemplates(body: string): JQueryPromise<void> {
        const dataTemplateRegex = /\bdata-(?:[A-z0-9]+-)*template=["'](.+?)["']/gi;
        let match = [];
        const promises = [];
        // eslint-disable-next-line no-cond-assign
        while (match = dataTemplateRegex.exec(body)) { 
            let dependencyName: string = match[1];
            const suffixMatchPosition: number = dependencyName.indexOf(this.templateSuffix);
            if ((suffixMatchPosition !== -1)
                && ((suffixMatchPosition + this.templateSuffix.length) === dependencyName.length)) {
                dependencyName = dependencyName.substr(0, suffixMatchPosition);
            }

            promises.push(this.getTemplate(dependencyName));
        }
        return $.when(...promises);
    }

    writeTemplate(name: string, body: string, target?: JQuery | string) {
        let t;
        if (typeof target === "string") {
            t = $(target);
        } else {
            t = target || $('body');
        }
        const el = document.createElement('script');
        el.type = 'text/x-kendo-template';
        el.text = body;
        el.setAttribute('name', name);
        el.setAttribute('id', name + this.templateSuffix);
        t.append(el);
    }

    getTemplateFilePath(name: string): string {
        return `${this.templatePath}/${name}.${this.templateExtension}`;
    }
}
